export const HeadlessDialogConstants = {
    height: 610,
    width: 900,
};
export const StoreAppId = 'f3a6e67f-850d-4dd9-960a-04c6638ded36';
export const GenerateShareLinkUrlFormat = '/{0}/{1}/{2}/{3}';
export const StoreHeadlessDialogUrl = 'https://teams.microsoft.com/extensibility-apps/appdetails/{0}/create?metaoshost=office&host=metaos&language={1}';
export const filteredEntityIdConversations = 'conversations';
export const filteredEntityIdAbout = 'about';
export const supportedStaticTabScopeInHarmony = 'personal';
//# sourceMappingURL=constants.js.map